import {lazy} from 'react';
import type {RouteObject} from 'react-router-dom';
import {Navigate} from 'react-router-dom';

import withSuspense from '@/routes/withSuspense';

const Updates = lazy(() => import('@/pages/mngt/update/Update'));
const LinkUpdate = lazy(() => import('@/pages/mngt/update/LinkUpdate'));
const SqlUpdate = lazy(() => import('@/pages/mngt/update/SqlUpdate'));
const InitUpdate = lazy(() => import('@/pages/mngt/update/InitUpdate'));

const updateRoutes: RouteObject[] = [
  {
    path: '/mngt/update',
    element: withSuspense(<Updates />),
    children: [
      {
        index: true,
        element: <Navigate to="link" replace />
      },
      {
        path: 'link',
        element: withSuspense(<LinkUpdate />)
      },
      {
        path: 'sql',
        element: withSuspense(<SqlUpdate />)
      },
      {
        path: 'init',
        element: withSuspense(<InitUpdate />)
      }
    ]
  }
];

export default updateRoutes;
